import React, { useState } from 'react';
import { Button, Form, Table } from 'react-bootstrap';
import './MessagesContent.css';

const MessagesContent = () => {
  const [selectedMessages, setSelectedMessages] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const messagesData = [
    {
      id: 1,
      date: '25.07.2025',
      question: 'Які документи потрібні для зарахування дитини в садочок?',
      child: 'Олена',
      answerDate: '26.07.2025',
      answer: 'Для зарахування дитини в садочок необхідно надати свідоцтво про народження, медичну довідку та заповнену заяву від батьків.'
    },
    {
      id: 2,
      date: '28.07.2025',
      question: 'Як часто ми можемо відвідувати садочок перед зарахуванням?',
      child: 'Ігор',
      answerDate: '29.07.2025',
      answer: 'Ви можете відвідати садочок не частіше одного разу на тиждень протягом двох місяців до зарахування.'
    },
    {
      id: 3,
      date: '01.08.2025',
      question: 'Яка тривалість навчального дня у садочку?',
      child: 'Марина',
      answerDate: '02.08.2025',
      answer: 'Тривалість навчального дня у садочку складає 6 годин, з 8:00 до 14:00, з можливістю продовженого дня до 17:00.'
    }
  ];

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);
    if (isChecked) {
      setSelectedMessages(messagesData.map(msg => msg.id));
    } else {
      setSelectedMessages([]);
    }
  };

  const handleSelectMessage = (id, isChecked) => {
    if (isChecked) {
      setSelectedMessages(prev => [...prev, id]);
    } else {
      setSelectedMessages(prev => prev.filter(msgId => msgId !== id));
    }
  };

  const handleNewMessage = () => {
    console.log('Создание нового сообщения');
    // Логика создания нового сообщения
  };

  const handleSearch = (e) => {
    console.log('Поиск:', e.target.value);
    // Логика поиска
  };

  return (
    <div className="messages-content">
      <div className="content-wrapper">
        {/* Заголовок страницы */}
        <h1 className="page-title">Мої повідомлення</h1>

        {/* Панель инструментов */}
        <div className="messages-toolbar">
          <div className="left-tools">
            <Button className="btn-new-message" onClick={handleNewMessage}>
              <i className="fa-solid fa-plus me-2"></i>Нове повідомлення
            </Button>
          </div>
          <div className="right-tools">
            <div className="search-box">
              <Form.Control
                type="text"
                className="search-input"
                placeholder="Швидкий пошук"
                onChange={handleSearch}
              />
              <i className="fa-solid fa-magnifying-glass"></i>
            </div>
          </div>
        </div>

        {/* Таблица сообщений */}
        <div className="messages-table-wrapper">
          <Table className="messages-table">
            <thead>
              <tr>
                <th style={{ width: '36px' }}>
                  <Form.Check
                    type="checkbox"
                    aria-label="Вибрати все"
                    checked={selectAll}
                    onChange={handleSelectAll}
                  />
                </th>
                <th>Дата звернення</th>
                <th>Питання</th>
                <th>Про кого</th>
                <th>Дата відповіді</th>
                <th>Відповідь</th>
              </tr>
            </thead>
            <tbody>
              {messagesData.map((message) => (
                <tr key={message.id}>
                  <td>
                    <Form.Check
                      type="checkbox"
                      aria-label="Вибрати"
                      checked={selectedMessages.includes(message.id)}
                      onChange={(e) => handleSelectMessage(message.id, e.target.checked)}
                    />
                  </td>
                  <td>{message.date}</td>
                  <td>{message.question}</td>
                  <td>{message.child}</td>
                  <td className="answer-date">{message.answerDate}</td>
                  <td className="answer-text">{message.answer}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default MessagesContent;